export const isRichTextContent = (content: string): boolean => /<[a-z][\s\S]*>/i.test(content);

export const getResourceDescription = (longDescription?: string | null, description?: string | null): string =>
  longDescription || description || '';
